import { RedirectOnRoot } from '@introducers-utils'
import { wrapCreateBrowserRouter } from '@sentry/react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'

import { NotFound, SentryErrorBoundary } from '@acre/design-system'
import { lazyRoute } from '@acre/utils'

import RequireAuth from '../RequireAuth'
import Root from '../Root'

// Wrapping the router enables Sentry peformance tracing
const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter)

const browserRouter = sentryCreateBrowserRouter([
  {
    path: '/',
    element: (
      <SentryErrorBoundary>
        <Root />
      </SentryErrorBoundary>
    ),
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        element: (
          <RequireAuth>
            <RedirectOnRoot />
          </RequireAuth>
        ),
      },

      { path: '*', element: <Navigate to="/" replace /> },
      { path: 'login', lazy: lazyRoute(() => import('./lazy/Login')) },
      { path: 'dashboard', lazy: lazyRoute(() => import('./lazy/Dashboard')) },

      {
        path: 'reports/:id',
        lazy: lazyRoute(() => import('./lazy/Reports')),
        children: [
          { path: 'caseStatusWaterfall', lazy: lazyRoute(() => import('./lazy/ReportsCaseWaterfall')) },
          { path: '*', element: <Navigate to="caseStatusWaterfall" replace /> },
        ],
      },
    ],
  },
])

const Router = () => {
  return <RouterProvider router={browserRouter} />
}

export default Router
